import { useEffect, useState } from "react";
import useFirestore from "./useFirestore";

const useHeader = () => {
    const uid = sessionStorage.getItem("uid") || "";
    const {readFirestoreOneDoc} = useFirestore();
    const [name, setName] = useState("");

    useEffect(() => {
        getName();
    }, [])

    const getName = async() => {
        let name = "";
        name = await readFirestoreOneDoc("User/Auth/Master", uid).then(res => {
            return res.exists() ? res.data().name : name; 
        })

        name = await readFirestoreOneDoc("User/Auth/Branch", uid).then(res => {
            return res.exists() ? res.data().name : name; 
        })

        name = await readFirestoreOneDoc("User/Auth/Teacher", uid).then(res => {
            return res.exists() ? res.data().name : name; 
        })

        setName(name);
    }

    return {name}
}

export default useHeader;